import { Entry } from 'contentful';
import { IProductPageFields, IProductPagesFields } from 'global';

/**
 * Cleans url from parameters
 */
export const getCleanPath = (path: string): string => path.split(/[?#]/)[0];

export const isCollectionPage = (
  page: Entry<IProductPageFields | IProductPagesFields>
): boolean => {
  return !!(page.fields.handle && page.fields.handle?.indexOf('collections') > -1);
};

/**
 * Extracts the collection slug from the path
 */
export const extractCollectionSlug = (path: string | null): string | null => {
  if (!path) return null;

  const cleanPath = getCleanPath(path);

  if (cleanPath.includes('/collections/')) {
    const match = cleanPath.match(/\/collections\/([^/]+)/);
    return match ? match[1] : null;
  }

  return null;
};
